import React from 'react';
import { FilterIcon, palette, SimplePopover, Tag } from '@dev/ee-components';

import { useContactQueryParams, useContactsAvailableStatuses } from '@/components/Contacts/Group/hooks';
import { useFilterActions } from '@/components/Contacts/Group/hooks/useFilterActions';

import { FilterContainer, FilterIconContainer, FilterLabel } from '../../../StyledComponents';

const CustomPopoverBody = (element: { [key: string]: boolean | string | number }): JSX.Element => (
    <FilterContainer>
        <FilterLabel>{element?.label}</FilterLabel>
        <Tag label={element?.count} clickable={false} />
    </FilterContainer>
);

export const DesktopStatusFilter = (): JSX.Element => {
    const availableStatuses = useContactsAvailableStatuses();
    const { queryStatuses } = useContactQueryParams();
    const { onStatusFilterClick } = useFilterActions();
    return (
        <SimplePopover
            id="desktop-status-filters"
            type="icon"
            enableCheckbox
            defaultCheckboxValue={queryStatuses}
            onCheckboxClick={onStatusFilterClick}
            options={availableStatuses}
            customDropdownBody={CustomPopoverBody}
            popperProps={{
                disablePortal: false,
            }}
        >
            <FilterIconContainer>
                <FilterIcon color={palette.gray[5]} />
            </FilterIconContainer>
        </SimplePopover>
    );
};
